<template>
  <div class="main training-history">
    <Sidebar
      :current-keywords="keywords"
      :current-filters="currentFilters"
      :filter-types="filterTypes"
      @search="setKeywords"
      @add-filter="addFilter"
      @remove-filter="removeFilter"
      @remove-all-filters="removeAllFilters"
    >
      <div slot="header" class="sidebar-header">
        <div class="title-bar">
          <h1 class="mb-1">Event Roster</h1>
          <h4 class="text-primary mb-3">{{ title }}</h4>
          <a
            class="btn-back"
            :href="route('training.history.index', { type: 'classroom' })"
          >
            <span class="icon icon-arrow-left"></span>
            <span class="text">Back to Training History</span>
          </a>
        </div>
      </div>
    </Sidebar>

    <div class="title-bar d-none d-xl-block pt-3">
      <template v-if="!!event.can_enroll_others">
        <a
          class="btn btn-info float-right ml-2 d-none d-lg-block"
          href="#"
          @click.prevent="showFileImportModal()"
          >Import Users</a
        >
        <a
          class="btn btn-info float-right ml-2 d-none d-lg-block"
          :href="route('enroll.classroom.event.others', { event: event.id })"
          >Register Others</a
        >
      </template>
      <h1 class="mb-1">Event Roster</h1>
      <h4 class="text-primary mb-3">{{ title }}</h4>
      <a
        class="btn-back"
        :href="route('training.history.index', { type: 'classroom' })"
      >
        <span class="icon icon-arrow-left"></span>
        <span class="text">Back to Training History</span>
      </a>
    </div>

    <div class="content p-3">
      <div class="row">
        <div class="col-12">
          <transition name="fade">
            <Alert v-if="hasAlert" :alert="alert" />
          </transition>

          <div class="row d-none d-xl-flex">
            <div class="col-5 col-xxl-4">
              <a
                v-if="items.length > 0"
                href="#"
                @click.prevent="showExportOptions()"
                class="btn btn-info mr-1"
              >
                <span class="icon icon-download"></span>
                <span class="text">Export List</span>
              </a>
              <a href="#" @click.prevent="printRoster()" class="btn btn-info"
                >Print Roster</a
              >
            </div>
            <div class="col-4 text-center">
              <Pagination
                class="d-inline-block"
                :total="totalPages"
                :value="parseInt(pagination.current)"
                @input="setCurrentPage"
              />
            </div>
            <div class="col-3 col-xxl-4 text-right">
              <PageSize
                :value="parseInt(pagination.per_page)"
                @input="setPerPage"
              />
            </div>
          </div>

          <EnrollmentList
            :items="items"
            :columns="columns"
            :activeColumns="activeColumns"
            :hideNoResults="hideNoResults"
            :listEvents="listEvents"
            @sort-by="setSort"
            @swap-column="setActiveColumn"
          />

          <div class="row">
            <div
              class="col-12 col-lg-5 col-xxl-4 mb-3 mb-lg-0 text-center text-lg-left"
            >
              <a
                v-if="items.length > 0"
                href="#"
                @click.prevent="showExportOptions()"
                class="btn btn-info mr-xl-1"
              >
                <span class="icon icon-download"></span>
                <span class="text">Export List</span>
              </a>
              <a
                href="#"
                @click.prevent="printRoster()"
                class="btn btn-info d-none d-xl-inline-block"
                >Print Roster</a
              >
            </div>
            <div class="col-12 col-lg-4 mb-3 mb-lg-0 text-center">
              <Pagination
                class="d-inline-block"
                :total="totalPages"
                :value="parseInt(pagination.current)"
                @input="setCurrentPage"
              />
            </div>
            <div class="col-12 col-lg-3 col-xxl-4 text-center text-lg-right">
              <PageSize
                :value="parseInt(pagination.per_page)"
                @input="setPerPage"
              />
            </div>
            <div
              v-if="!!event.can_enroll_others"
              class="d-lg-none col-12 text-center pt-4"
            >
              <a
                class="btn btn-info"
                :href="route('enroll.classroom.event.others', routeParam)"
                >Register Others</a
              >
            </div>
            <div
                v-if="!!event.can_enroll_others"
                class="d-lg-none col-12 text-center pt-4"
            >
              <a
                  class="btn btn-info"
                  href="#"
                  @click.prevent="showFileImportModal()"
              >Import Users</a
              >
            </div>
          </div>

          <template v-if="event.can_view_roster || event.can_upload_flyer">
            <hr />
            <div class="row d-none d-xl-flex">
              <div class="col-12 text-right">
                <a
                    v-if="event.can_upload_roster"
                    href="#"
                    @click.prevent="showRosterUpload()"
                    class="btn btn-success"
                >
                  <span class="icon icon-download"></span>
                  <span class="text">Roster Upload</span>
                </a>
                <a
                    v-if="event.can_view_roster && !!this.event.roster_upload"
                    :href="route('training.events.roster.download', routeParam)"
                    :data-file="filename"
                    class="btn btn-success ml-2"
                >
                  <span class="icon icon-courses"></span>
                  <span class="text">View Uploaded File</span>
                </a>
                <a
                  v-if="event.can_upload_flyer"
                  href="#"
                  @click.prevent="showFlyerUpload()"
                  class="btn btn-success ml-1"
                >
                  <span class="icon icon-download"></span>
                  <span class="text">{{ event.flyer_upload ? 'View Uploaded Flyer' : 'Flyer Upload' }}</span>
                </a>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import ListingMixin from "mixins/Listing";
import EnrollmentList from "components/partials/Events/EnrollmentList";
import FileImportModal from "components/partials/FileImportModal";
import RosterUploadModal from "components/partials/Events/RosterUploadModal";
import FlyerUploadModal from "components/partials/Events/FlyerUploadModal";

export default {
  mixins: [DisplaysAlerts, ListingMixin],
  components: {
    EnrollmentList,
    FileImportModal,
    RosterUploadModal,
    FlyerUploadModal,
  },
  props: {
    event: { type: Object, required: true },
    sampleImportFile: { type: String },
    maxUpload: { type: String, required: true },
  },
  computed: {
    routeParam() {
      return { event: this.event.id };
    },
    title() {
      return (
        `${this.event.name} - ` +
        this.$moment(this.event.start_date).format("MM/DD/YYYY") +
        ` (ID: ${this.event.id})`
      );
    },
  },
  methods: {
    printRoster() {
      var url = this.route(
        "training.events.enrollments.print",
        this.routeParam
      );
      url += "?pagination[current]=1";
      url += "&pagination[per_page]=1000";
      url += "&sort[column]=" + encodeURIComponent(this.sort.column);
      url += "&sort[dir]=" + this.sort.dir;
      window.open(url, "_blank");
    },
    showFileImportModal() {
      var importUrl = this.route(
        "training.events.enrollments.import",
        this.routeParam
      );
      this.$modal(FileImportModal, {
        title: "Import to Event Roster",
        import_url: importUrl,
        sample_file: this.sampleImportFile,
      })
        .then(() => {
          this.refresh();
        })
        .catch(() => {});
    },
    showRosterUpload() {
      this.$modal(RosterUploadModal, {
        event: this.event,
        maxUpload: this.maxUpload,
      })
        .then(() => {})
        .catch(() => {});
    },
    showFlyerUpload() {
      this.$modal(FlyerUploadModal, {
        event: this.event,
        maxUpload: this.maxUpload,
      })
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>
